/**
 * Client-only Vuex store — ships only the `glb` (global) module.
 *
 * Page-specific modules (msp, dpp, home, agents, …) are dynamically imported
 * and registered via `store.registerModule()` in entry-client.js BEFORE the
 * app mounts.  This avoids bundling all 18 store modules into the main
 * client bundle, reducing JS parse + evaluation time significantly.
 *
 * The full store (with all modules) is still used on the server
 * (vweb/common/store/index.js) because SSR has no bundle-size concern.
 */
import glb from './glb/index.js';
import { createStore } from 'vuex';

export default () => {
    return createStore({
        modules: { glb },
        devtools: true,
    });
};
